module.exports = __webpack_public_path__ + "static/img/8.ef23eb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/imgs/8.png
// module id = OryP
// module chunks = 0